module.exports = __webpack_public_path__ + "static/mtfp-social-app-placard-1256645588d4fdb842ee3a860129759b.png";